import { PageHero } from "@/src/components/PageHero";
import { SubscriptionOptions } from "./(sections)/SubscriptionOptions";
import { Newsletter } from "@/src/pages/home/(sections)/newsletter/Newsletter";

export function SubscriptionPage() {
    return (
        <>
            <PageHero
                image="https://images.unsplash.com/photo-1513885535751-8b9238bd345a?auto=format&fit=crop&q=80&w=2000"
                label="Scent delivered to your door"
                title="Subscribe"
            />
            <SubscriptionOptions />
            <Newsletter />
        </>
    );
}
